import colors from "../../styles/colors";
import styled from "styled-components";

export default styled.button`
  transition: all .1s ease;
  cursor: pointer;
  background: ${colors.offWhite};
  color: ${colors.text};
  border: 0;
  padding: .5rem 1rem;
  border-radius: .3rem;

  :hover {
    background: ${colors.textHover};
  }
`